import { useEffect } from 'react'
import { useCallStore } from '../stores/callStore'

/**
 * 通話時間を1秒ごとに更新するグローバルタイマー
 *
 * このフックはLayoutコンポーネントで1回だけ呼び出され、
 * アプリケーション全体で1つのタイマーのみを実行します。
 */
export function useCallDurationTimer(): void {
  useEffect(() => {
    /**
     * 通話時間を更新する関数
     */
    const updateDuration = () => {
      const state = useCallStore.getState()

      // 外線通話の時間を更新
      if (state.callStatus === 'connected' && state.callStartTime) {
        const duration = Math.floor((Date.now() - state.callStartTime) / 1000)
        useCallStore.setState({ callDuration: duration })
      }

      // 内線通話の時間を更新
      // NOTE: internalCallStartTime / internalCallDuration は将来の拡張用
      // 現時点では callStore に定義されていないが、setState は unknown keys を許容する
      const internalState = state as unknown as Record<string, unknown>
      if (state.internalCallStatus === 'connected' && typeof internalState.internalCallStartTime === 'number') {
        const duration = Math.floor((Date.now() - (internalState.internalCallStartTime as number)) / 1000)
        useCallStore.setState({ internalCallDuration: duration } as Record<string, unknown>)
      }
    }

    // 1秒ごとに更新
    const intervalId = setInterval(updateDuration, 1000)

    // クリーンアップ
    return () => {
      clearInterval(intervalId)
    }
  }, [])
}

export default useCallDurationTimer
